import { Avatar, Breadcrumbs, Stack, Typography } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { Page } from '../../../design/page/Page';
import { EikenMaterialManualForm } from '../create-manual/components/EikenMaterialManualForm';
import { useEffect, useMemo } from 'react';
import { EikenMaterialData, EikenMaterialResource } from '../../../resources';
import { useRequester } from '../../../hooks';

export function EikenMaterialUpdateManual() {
  const { user } = useAuth();
  const testInitials =
    (user?.data.firstName?.charAt(0) || '') + (user?.data.lastName?.charAt(0) || '');

  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const ids = useMemo(() => id?.split(',') || [], [id]);

  // no tabs on this page, therefore 0
  const currentId = ids[0];

  const fetchMaterial = useRequester<EikenMaterialResource>({
    onSubmit: (id) => EikenMaterialResource.fetchOne(id),
    onError: console.log,
  });

  const data = EikenMaterialResource.get(currentId).data as EikenMaterialData;

  useEffect(() => {
    fetchMaterial.submit(currentId);
  }, [currentId]);

  if (!id || !data) return <></>;

  return (
    <Page>
      <Page.Header sx={{ height: 'auto', pt: 4, pb: 2, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Link to="/eiken-materials">
            <Typography color="text.secondary" variant="body2">
              &lt; Back to questions
            </Typography>
          </Link>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
          <Avatar
            sx={{ bgcolor: 'border.primary', width: 56, height: 56, fontSize: 24, fontWeight: 600 }}
          >
            {testInitials}
          </Avatar>
          <div>
            <Breadcrumbs aria-label="breadcrumb">
              <Link className="underline" color="inherit" to="/eiken-materials">
                Questions
              </Link>
              <Typography color="text.primary">Create Test</Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ fontWeight: 600 }}>
              Update material
            </Typography>
          </div>
        </Stack>
      </Page.Header>
      <Page.Content>
        <EikenMaterialManualForm eikenMaterial={data} />
      </Page.Content>
    </Page>
  );
}
